/**
 * Rugby Culture - Cart page
 * Pairs with sections/rc-main-cart.liquid and assets/rc-main-cart.css
 *
 * Same Ajax Cart API + Section Rendering API pattern as rc-cart-drawer.js.
 * Dispatches the same "rc:cart:updated" event, so the header badge stays
 * in sync no matter whether a change happened in the drawer or here.
 */
(function () {
  const SECTION_ID = 'rc-main-cart';

  const root = document.getElementById('rc-main-cart-content');
  if (!root) return;

  function setLoading(isLoading) {
    root.classList.toggle('is-loading', isLoading);
  }

  async function refreshCart() {
    setLoading(true);
    try {
      const url = window.location.pathname + window.location.search +
        (window.location.search ? '&' : '?') + 'section_id=' + SECTION_ID;
      const response = await fetch(url);
      const html = await response.text();
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const freshRoot = parsed.getElementById('rc-main-cart-content');
      if (freshRoot) {
        root.innerHTML = freshRoot.innerHTML;
      }
    } catch (err) {
      console.error('Rugby Culture cart page: failed to refresh.', err);
    } finally {
      setLoading(false);
    }
  }

  async function fetchCartJson() {
    const response = await fetch('/cart.js');
    return response.json();
  }

  async function notifyCartUpdated() {
    const cart = await fetchCartJson();
    document.dispatchEvent(new CustomEvent('rc:cart:updated', { detail: { cart } }));
    document.querySelectorAll('[data-cart-count]').forEach(function (badge) {
      badge.textContent = cart.item_count;
      badge.hidden = cart.item_count === 0;
    });
  }

  async function changeLineQuantity(lineKey, quantity) {
    setLoading(true);
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity: quantity })
      });
      if (!response.ok) {
        const error = await response.json();
        console.error('Rugby Culture cart page:', error.description || error.message);
      }
      await refreshCart();
      await notifyCartUpdated();
    } catch (err) {
      console.error('Rugby Culture cart page: quantity change failed.', err);
      setLoading(false);
    }
  }

  async function addVariantToCart(variantId) {
    setLoading(true);
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      });
      if (!response.ok) {
        const error = await response.json();
        alert(error.description || 'This item could not be added to your cart.');
        setLoading(false);
        return;
      }
      await refreshCart();
      await notifyCartUpdated();
    } catch (err) {
      console.error('Rugby Culture cart page: add to cart failed.', err);
      setLoading(false);
    }
  }

  root.addEventListener('click', function (event) {
    const decreaseBtn = event.target.closest('[data-cart-qty-decrease]');
    const increaseBtn = event.target.closest('[data-cart-qty-increase]');
    const removeBtn = event.target.closest('[data-cart-remove]');
    const addBtn = event.target.closest('[data-cart-add]');

    if (decreaseBtn || increaseBtn) {
      const btn = decreaseBtn || increaseBtn;
      const lineKey = btn.getAttribute('data-line-key');
      const row = btn.closest('.rc-cart-item');
      const qtyEl = row ? row.querySelector('[data-cart-qty-value]') : null;
      const currentQty = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
      const newQty = decreaseBtn ? Math.max(0, currentQty - 1) : currentQty + 1;
      changeLineQuantity(lineKey, newQty);
      return;
    }

    if (removeBtn) {
      changeLineQuantity(removeBtn.getAttribute('data-line-key'), 0);
      return;
    }

    if (addBtn && !addBtn.disabled) {
      addVariantToCart(addBtn.getAttribute('data-variant-id'));
      return;
    }
  });

  // Discount codes can't be previewed on the classic cart, so send the
  // shopper straight to checkout with the code pre-applied.
  root.addEventListener('submit', function (event) {
    const form = event.target.closest('#rc-discount-form');
    if (!form) return;
    event.preventDefault();
    const input = form.querySelector('input[name="discount"]');
    const code = input ? input.value.trim() : '';
    window.location.href = code ? '/checkout?discount=' + encodeURIComponent(code) : '/checkout';
  });
})();